import * as angular from "angular";
import {IQService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";
import {ApiConfig} from "../../commons/models/api-config.model";

export class AttachmentsRequests {

  /* @ngInject */
  constructor(private attachmentsAPI: BringozApi, private $attachments, private splitService: SplitService,
              private Upload, private apiConfig: ApiConfig, private $q: IQService) {
  }
  // ******************************
  //        Public methods
  // ******************************

  getAttachmentUrl(name) {
    const api = this.attachmentsAPI.actions.getUrl;
    return this.$$call(api, {}, {}, {}, name);
  }

  getAttachmentsUrls(names: string[]) {
    const api = this.attachmentsAPI.actions.getUrl;
    return this.$$call(api, {names: names}, {}, {});
  }

  addAttachment(attachment) {
    const deferred = this.$q.defer();
    const siteId = this.splitService.getSiteId();

    this.Upload.upload({
      url: this.apiConfig.baseUrl + `/attachments`,
      method: 'PUT',
      params: {
        siteId: siteId
      },
      data: {
        file: attachment
      }
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      });

    return deferred.promise;
  }

  // ******************************
  //        Private methods
  // ******************************


  $$call(_apiCall, _params, _data, _options, _id?) {
    return this.$attachments(_id).$call(_apiCall, _params, _data, _options);
  }
}
angular
  .module('bringoz.admin.attachments')
  .service('attachmentsRequests', AttachmentsRequests);
